<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
    custom-class="custom-scrollable"
  >
    <div class="font-normal">
      <div class="flex justify-center mt-10"><circle-icon /></div>
      <div class="text-xl mt-4 font-bold text-primary flex justify-center">
        Deposit Pending
      </div>
      <div style="word-break: normal" class="text-center text-root-4 mx-2">
        <p class="my-3">
          1. A pending deposit requires you to initiate a funds transfer from
          your financial institution. Your deposit is labelled pending until
          Oval receives funds.
        </p>
        <p class="my-3 text-sm">
          2. Please ensure you use the correct reference number when making a
          deposit.
        </p>
        <p class="my-3 text-sm">
          3. You will not be able to initiate a new deposit until this deposit
          is confirmed
        </p>
      </div>

      <div class="mx-4 border-none my-4">
        <o-button @click="depositComplete">I Understand</o-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      breakpoints
    }
  },
  methods: {
    depositComplete () {
      this.$emit('completedDeposit')
      this.$emit('closeDialog')
    },
    handleClose () {
      this.$emit('closeDialog')
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '35%' : breakpoints.mdAndUp ? '70%' : '90%'
    }
  },
  components: {
    CircleIcon: () => import('@/assets/icons/CircleIcon.vue')
  }
}
</script>

<style scoped>
>>> .el-dialog {
  border-radius: 30px;
  padding: 0px 20px 10px 10px;
}
>>> .el-dialog__body {
  padding: 0px 20px;
}
>>> .el-dialog__wrapper {
  overflow: hidden;
  top: 14px;
}
>>> .el-icon-close:before {
  padding: 25px;
  opacity: 0.9;
  color: #c1c4ca;
}
>>> .el-dialog__headerbtn :hover {
  color: #c1c4ca !important ;
}
</style>
